import PortalModal from '../../common/PortalModal';

export default function CodecModal({ id, title, isOpen, toggleModalOpen, children }) {
  return (
    <PortalModal
      title={title}
      maxWidth="sm"
      isOpen={isOpen}
      onClose={toggleModalOpen}
      isCloseable
      id={`${id}__model`}
    >
      {children}
    </PortalModal>
  );
}
